export default __webpack_public_path__ + "static/media/excel-essentials-for-data-analytics.6955aeea.png";